import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import ExitToApp from "@material-ui/icons/ExitToApp";
// core components
import Button from "components/CustomButtons/Button.js";
import Typography from "@material-ui/core/Typography";
import PopupLogout from "views/dialog/PopupLogout";

import styles from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";

const useStyles = makeStyles(styles);

export default function AdminNavbarLinks() {
  const classes = useStyles();
  const [popupLogout, setpopupLogout] = React.useState(false);

  const handleOpenpopupLogout = () => {
    setpopupLogout(true);
  };

  const handleClosepopupLogout = () => {
    setpopupLogout(false);
  };

  return (
    <div className={classes.manager}>
      <Button
        color={window.innerWidth > 959 ? "transparent" : "white"}
        aria-haspopup="true"
        // onClick={handleClickProfile}
        onClick={handleOpenpopupLogout}
        className={classes.buttonLink}
      >
        <ExitToApp className={classes.icons} />
        <Typography variant="subtitle2" align="center">
          Salir
        </Typography>
      </Button>

      {popupLogout ? (
        <PopupLogout open={popupLogout} exit={handleClosepopupLogout} />
      ) : (
        ""
      )}
    </div>
  );
}
